import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

// One shared, Dutch delete confirmation for every screen — no native
// window.confirm, no silent one-tap deletes. Wrap the existing trigger button.
export const DeleteConfirm = ({ trigger, title, description, onConfirm, confirmLabel = "Verwijderen", testid }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent srDescription="Bevestig deze actie of annuleer om terug te gaan.">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Annuleren</AlertDialogCancel>
        <AlertDialogAction data-testid={testid} onClick={onConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
